import React, { useState, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import PhotoGrid from './components/PhotoGrid';
import PhotoDetail from './components/PhotoDetail';
import Footer from './components/Footer';
import './App.css';

function App() {
  const [filterState, setFilterState] = useState({
    activeFilter: null,
    loading: false,
    disabled: false
  });

  const handleFilterApply = useCallback((filter) => {
    setFilterState(prev => ({ ...prev, activeFilter: filter }));
  }, []);

  const handleFilterClear = useCallback(() => {
    setFilterState(prev => ({ ...prev, activeFilter: null }));
  }, []);

  const updateFilterState = useCallback((updates) => {
    setFilterState(prev => ({ ...prev, ...updates }));
  }, []);

  return (
    <Router>
      <div className="App">
        <Header 
          activeFilter={filterState.activeFilter}
          onFilterApply={handleFilterApply}
          onFilterClear={handleFilterClear}
          loading={filterState.loading}
          disabled={filterState.disabled}
        />
        <main className="main-content">
          <Routes>
            <Route 
              path="/" 
              element={
                <PhotoGrid 
                  filterState={filterState}
                  onFilterApply={handleFilterApply}
                  onFilterClear={handleFilterClear}
                  updateFilterState={updateFilterState}
                />
              } 
            />
            <Route path="/photo/:id" element={<PhotoDetail />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;